/**
 * 用户相关API配置
 * {
 *   name: 调用接口的别名
 *   url：api
 *   method：get | post | put | delete
 * }
 */
export default {
  // 项目类别
  getProjectType: {
    name: "getProjectType",
    url: "/BaseData?value=ProjectType",
    method: "get"
  },
  // 负载均衡
  getLoadBalancer: {
    name: "getLoadBalancer",
    url: "/BaseData?value=LoadBalancer",
    method: "get"
  },
  // 参数类型
  getParamType: {
    name: "getParamType",
    url: "/BaseData?value=ParamType",
    method: "get"
  },
  // 担保物类型
  getCollateralType: {
    name: "getCollateralType",
    url: "/ams/amsEnums/collateralType",
    method: "get"
  },
  // 担保类型
  getGuaranteeType: {
    name: "getGuaranteeType",
    url: "/ams/amsEnums/guaranteeType",
    method: "get"
  },
  // 获取银行类型
  getBankCodeType: {
    name: "getBankCodeType",
    url: "/ams/allinpay/bankCodeList",
    method: "get"
  }
};
